import React from "react";
import { Link, useNavigate } from "react-router-dom"
import { Button } from '@material-ui/core'

function Navigation() {

    const currentUser = localStorage.getItem("firstName") + " " + localStorage.getItem("secondName") || "user"
    const navigate = useNavigate();

    const logout = () => {
        localStorage.clear();
        navigate('/login');
    }

    return (
        <div className="navigationContainer">
            <nav>
                <Link to='/studentHomepage' className="navLink">
                    <p>Home</p>
                </Link>
                <Link to='/viewProjects' className="navLink">
                    <p>Projects</p>
                </Link>
                <Link to='/createEditProject' className="navLink">
                    <p>Create/Edit Project</p>
                </Link>
                <Link to='/viewShortlist' className="navLink">
                    <p>Shortlist</p>
                </Link>
                <Link to='/makeChoices' className="navLink">
                    <p>Project Choices</p>
                </Link>
                <Link to='/viewFinalAllocation' className="navLink">
                    <p>Final Allocation</p>
                </Link>
                {currentUser ? (
                    <div className="navOptions">
                        <p>{currentUser}</p>
                        <Button onClick={logout}><p className="buttontext">Logout</p></Button>
                    </div>
                ) : (
                    <Link to="/login">
                    <button type="button">
                        Sign in
                    </button>
                </Link>
                )}
            </nav>
        </div>
    ) 
}

export default Navigation